import { useEffect } from 'react';
import { useLocation, useNavigate } from '@/lib/router-compat';

// Normalizes any uppercase path to lowercase to avoid 404s like /UK/hub/BMW
// Preserves search and hash, and collapses duplicate slashes
export default function LowercaseRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;
    if (!pathname) return;

    // Collapse multiple slashes and convert to lowercase
    const collapsed = pathname.replace(/\/+/g, '/');
    const lower = collapsed.toLowerCase();

    if (pathname !== lower) {
      navigate(lower + (search || '') + (hash || ''), { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}
